module.exports = __webpack_public_path__ + "img/socialInsurance.46e9eaba.png";